import { Container } from "reactstrap";

export default function ContainerPadded(props: { children?: React.ReactNode; }) {
    return (
        <Container className="pt-3">
            {props.children}
        </Container>
    );
}